import React from 'react';
import { G, Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

// Numbered-list glyph for the message text-styles toolbar. Same glyph as the
// Gripp OS MessageComposer (Slack-style, not a Figma icon export).
export const OrderedListIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <G
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <Path d="M10 6h11M10 12h11M10 18h11" />
      <Path d="M4 4.5L5.5 4V9M4 9h3" />
      <Path d="M3.5 15.5c0-1 2-1 2 0.2S3.5 17 3.5 18.5h2.5" />
    </G>
  </Svg>
);

OrderedListIcon.displayName = 'OrderedListIcon';
